import { render, staticRenderFns } from "./newAdvertisement.vue?vue&type=template&id=02b8439e&scoped=true&"
import script from "./newAdvertisement.vue?vue&type=script&lang=js&"
export * from "./newAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8439e",
  null
  
)

export default component.exports